// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".backface-hidden{-webkit-backface-visibility:hidden;backface-visibility:hidden}.exit-to-corner{transform:translate(40%,-20%) rotate(30deg)!important;opacity:1}.return-to-deck{transform:translate(8px,16px) rotate(4deg)!important;opacity:.8;z-index:0!important;transition:all .3s ease}.stacked-card{transform:translate(4px,8px) rotate(2deg)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
